/**
 * FIN-1708 · the two screens the pre-approval popup carries an inversionista into.
 *
 * Shared because both ends of the journey need the same string: `app.component` sets
 * `?returnUrl=` when it sends someone to create a cuenta bancaria, and
 * `create-bank-accounts.template` checks the parameter against this list before spending
 * it. A literal on either side is a redirect that silently stops working.
 */
export const DEPOSIT_ROUTE = '/financial-transactions/deposit';

export const BANK_ACCOUNT_CREATE_ROUTE = '/bank-accounts/create';

/** Where creating a cuenta bancaria has always ended, and still does by default. */
export const BANK_ACCOUNTS_ROUTE = '/bank-accounts';

/**
 * ⚠ An allowlist, not a passthrough. `returnUrl` arrives from the query string, so
 * navigating to whatever it contains would let a crafted link bounce an investor
 * somewhere of the sender's choosing after a successful write.
 */
const RETURN_URL_ALLOWLIST: string[] = [DEPOSIT_ROUTE, BANK_ACCOUNTS_ROUTE];

export const resolveReturnUrl = (candidate: string | null | undefined): string =>
  RETURN_URL_ALLOWLIST.includes(candidate) ? candidate : BANK_ACCOUNTS_ROUTE;
